<section class="wizard-panel">
  <div class="wizard-intro">
    <h2>Classification Eligibility Statements</h2>
    <p>
      Operations included and excluded selected to describe the applicant's business and operations.
      Coverage under the policy only applies to injury or damage caused by operations included in the
      listed classifications.
    </p>
  </div>

  @for (statement of classes(); track statement.classCode) {
    <lib-card>
      <div cardTitle>
        <p class="small bold">
          {{ statement.classCode }} - {{ statement.className }}
          @if (statement.payroll != null) {
            - Payroll: {{ statement.payroll | currency: 'USD' }}
          }
        </p>
        <p class="small">{{ statement.classDescription }}</p>
      </div>
      <div class="statement-html" [innerHTML]="statement.eligibleStatement"></div>
      <div class="statement-html" [innerHTML]="statement.ineligibleStatement"></div>
    </lib-card>
  }
</section>

<div class="wizard-footer">
  <lib-buttons cssType="btn-primary-outline" size="small" text="← Back" (click)="back.emit()" />
  <lib-buttons size="small" text="Next →" (click)="next.emit()" />
</div>
